import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React, { Component } from "react"
import { Accordion, Card } from "react-bootstrap"
import { FormattedMessage, FormattedNumber, injectIntl } from "react-intl"
import OutsideClickHandler from "react-outside-click-handler"
import EventBus from "../../../../common/EventBus.js"
import GlobalHelper from "../../../../common/GlobalHelper.jsx"
import Checkbox from "../../../../common/checkbox/checkbox.component.jsx"
import Document from "../../../../common/document/document.component.jsx"
import Icon from "../../../../common/icon/icon.component.jsx"
import ImageGallery from "../../../../common/image/gallery.component.jsx"
import BundleOptionsDisplay from "../../../../common/pricing/add-item-modal/components/BundleOptionsDisplay"
import CommitmentDurationLabel from "../../../../common/pricing/commitmentdurationlabel.component.jsx"
import GroupCalendarEventsDescription from "../../../../common/quote/groupcalendareventsdescription.component.jsx"
import QuoteGroupName from "../../../../common/quote/groupname.component.jsx"
import QuoteItemPrice from "../../../../common/quote/itemprice.component.jsx"
import Radio from "../../../../common/radio/radio.component.jsx"
import InputUnitOfMeasure from "../../../../common/unit-of-measure/input.component.jsx"
import LabelUnitOfMeasure from "../../../../common/unit-of-measure/label.component.jsx"
import LabelAmountPerUnitOfMeasure from "../../../../common/unit-of-measure/perunit.component.jsx"
import BillingMethodLabel from "../../../../product/billing-method/label.component.jsx"
import SerialNumberLabelListing from "../../../../product/serial-number/SerialNumberLabelListing"
import { PAYMENT_STATUS } from "../../../../state/helpers/Payment"
import CustomAttributeValueService from "../../../../state/product-custom-attributes/CustomAttributeDefinitionService"
import Product from "../../../../state/product/Product"
import { PRODUCT_TYPE } from "../../../../state/product/Types"
import {
    CUSTOM_ATRRTRIBUTES_SELECT_ADD_OPTION,
    CUSTOM_ATRRTRIBUTES_SELECT_REMOVE_OPTION,
    CUSTOM_ATTRIBUTE_TYPE_SELECT,
    CUSTOM_ATTRIBUTE_TYPE_TEXT
} from "../../../../utils"
import ProposalMergeFields from "../../../MergeFields.jsx"
import SectionWrapper from "../../sectionwrapper.component.jsx"
import SectionContentTypes from "../ContentTypes.jsx"
import ProductCustomAttributesComponent from "./product-custom-attribute/ProductCustomAttributesComponent"
import ProductTitle from "./producttitle.component.jsx"
import DocumentPricingTableTotal from "./total.component.jsx"

const uuidv4 = require("uuid/v4")
const cookieKey = "qm_pt_data"

function findOptionsOfAMultipleChoiceGroup(groupId, currentGroupNumber, isPdf) {
    if (!isPdf) {
        var $ = require("jquery/dist/jquery.min.js")
        let itemIds = new Set()
        let groupItems = $(`[name=Group-${groupId}-${currentGroupNumber}]`)
        for (let item of groupItems) {
            itemIds.add(item.id)
        }
        return itemIds
    }
}

class PricingTableContentSection extends Component {
    constructor(props, context) {
        super(props, context)

        this.state = {
            syncId: "pricing-table-section" + uuidv4(),
            groups: this.props.variables.quote.groups || [],
            section: this.props.section || null,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            isPdf: this.props.isPdf || false,
            isDummy: this.props.isDummy || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function () { },
            mobile: this.props.mobile || false,
            itemOptions: [],
            items: [],
            itemCustomAttributeValues: [],
            itemDescriptions: [],
            taxCalculations: [],
            totals: [],
            calendarEvents: [],
            optionsSelected: {},
            itemQuantities: {},
            maxRowQuantities: {},
            itemQuantitiesShown: [],
            subtotalAmount: "0",
            discountAmount: "0",
            taxAmount: "0",
            totalAmount: "0",
            columnWidths: {
                columnWidth1: "10%",
                columnWidth2: "40%",
                columnWidth3: "30%",
                columnWidth4: "20%"
            },
            mobileColumnWidths: {
                columnWidth1: "40%",
                columnWidth2: "60%"
            },
            choicesSelected: {},
            multipleChoiceOptions: {},
            activeGroupsKeys: []
        }
        if (this.state.variables) {
            this.state.optionsSelected = this.formatOptions(this.state.variables)
            this.state.choicesSelected = this.formatSelectedChoices(this.state.variables)
            this.state.multipleChoiceOptions = this.formatMultipleOptions(this.state.variables)
            this.state.itemQuantities = this.formatItemQuantities(this.state.variables)
            this.state.itemCustomAttributeValues = this.formatCustomValues(this.state.variables)
            this.state.totals = this.state.variables.quote.totals
            this.state.items = this.state.variables.quote.items
            this.state.subtotalAmount = this.state.variables.quote.subtotalAmount
            this.state.discountAmount = this.state.variables.quote.discount.amount
            this.state.depositAmount = this.state.variables.quote.depositAmount
            this.state.depositBalance = this.state.variables.quote.depositBalance
            this.state.taxCalculations = this.state.variables.quote.taxCalculations
            this.state.taxAmount = this.state.variables.quote.taxAmount
            this.state.totalAmountWithoutTax = this.state.variables.quote.totalAmountWithoutTax
            this.state.totalAmount = this.state.variables.quote.totalAmount
            this.state.itemOptions = this.formatItemOptions(this.state.variables)
            this.state.rulesInfo = this.formatRules(this.state.variables)
            this.state.maxRowQuantities = this.formatRowMaxQuantities(this.state.variables)
        }
        this.isQuantityValid = this.isQuantityValid.bind(this)
        this.isQuantityChangeValid = this.isQuantityChangeValid.bind(this)
        this.handleOptionChange = this.handleOptionChange.bind(this)
        this.handleChoiceChange = this.handleChoiceChange.bind(this)
        this.handleProposalSubmit = this.handleProposalSubmit.bind(this)
        this.updateProposalWithSyncState = this.updateProposalWithSyncState.bind(this)
        this.selectItemOfAMultipleChoiceGroup = this.selectItemOfAMultipleChoiceGroup.bind(this)
        this.unselectOtherItemsOfAMultipleChoiceGroup = this.unselectOtherItemsOfAMultipleChoiceGroup.bind(this)
        this.getEndPoint = this.getEndPoint.bind(this)
        this.onChangeGroup = this.onChangeGroup.bind(this)
        this.renderItems = this.renderItems.bind(this)
        this.handlePricingTableSync = this.handlePricingTableSync.bind(this)
        this.handleCustomAttributeChange = this.handleCustomAttributeChange.bind(this)
        this.unsubscribe = this.unsubscribe.bind(this)
        this.handleGroupSelect = this.handleGroupSelect.bind(this)
        this.activeGroupsKeysContains = this.activeGroupsKeysContains.bind(this)
        this.getBundleItems = this.getBundleItems.bind(this)

        for (const item of this.state.items) {
            if (!this.isQuantityValid(item.id)) {
                this.state.itemQuantitiesShown.push(item.id)
            }
        }
        this.setUpListeners()
    }

    setUpListeners() {
        const syncId = this.state.syncId
        EventBus.listen(EventBus.TopicProposalPreApproved, syncId, this.handleProposalSubmit)
        EventBus.listen(EventBus.TopicProposalPreDeclined, syncId, this.handleProposalSubmit)
        EventBus.listen(EventBus.TopicProposalRefresh, syncId, this.handleProposalSubmit)
        EventBus.listen(EventBus.TopicSyncPricingTables, syncId, this.handlePricingTableSync)
    }

    unsubscribe() {
        const syncId = this.state.syncId
        EventBus.unsubscribe(EventBus.TopicProposalPreApproved, syncId, this.handleProposalSubmit)
        EventBus.unsubscribe(EventBus.TopicProposalPreDeclined, syncId, this.handleProposalSubmit)
        EventBus.unsubscribe(EventBus.TopicProposalRefresh, syncId, this.handleProposalSubmit)
        EventBus.unsubscribe(EventBus.TopicSyncPricingTables, syncId, this.handlePricingTableSync)
    }

    componentWillUnmount() {
        this.unsubscribe()
    }

    handlePricingTableSync(event) {
        let synchronizedState = event.getData()
        if (!synchronizedState.variables) {
            return
        }

        this.setState({
            optionsSelected: synchronizedState.optionsSelected,
            choicesSelected: synchronizedState.choicesSelected,
            multipleChoiceOptions: synchronizedState.multipleChoiceOptions,
            itemQuantities: synchronizedState.itemQuantities,
            totals: synchronizedState.totals,
            items: synchronizedState.items,
            subtotalAmount: synchronizedState.subtotalAmount,
            discountAmount: synchronizedState.discountAmount,
            depositAmount: synchronizedState.depositAmount,
            depositBalance: synchronizedState.depositBalance,
            taxCalculations: synchronizedState.taxCalculations,
            taxAmount: synchronizedState.taxAmount,
            totalAmountWithoutTax: synchronizedState.totalAmountWithoutTax,
            totalAmount: synchronizedState.totalAmount,
            itemOptions: synchronizedState.itemOptions,
            groups: synchronizedState.variables.quote.groups || []
        })

        this.updateProposalWithSyncState(synchronizedState)

    }

    selectItemOfAMultipleChoiceGroup(groupItemIds, currentItemId) {
        let choicesSelected = Object.assign({}, this.state.choicesSelected)
        for (let id of groupItemIds) {
            choicesSelected[id] = false
        }
        choicesSelected[currentItemId] = true
        return choicesSelected
    }

    unselectOtherItemsOfAMultipleChoiceGroup(groupItemIds, currentItemId) {
        let multipleChoiceOptions = Object.assign({}, this.state.multipleChoiceOptions)
        for (let id of groupItemIds) {
            multipleChoiceOptions[id] = true
        }
        multipleChoiceOptions[currentItemId] = false
        return multipleChoiceOptions
    }

    componentDidMount() {
        EventBus.dispatch(EventBus.TopicPricingTableOptionsSelectedChanged, {
            itemCustomAttributeValues: this.getCustomValues(),
            options: this.getOptionsSelected(),
            selectedChoices: this.getChoicesSelected(),
            multipleChoiceOptions: this.getMultipleChoiceOptions(),
            itemQuantities: this.getBillableItemQuantities()
        })

        if (this.state.section.attributes.content.enableCollapsibleGroups && this.state.section.attributes.content.enableSingleCollapsibleGroups) {
            this.setState({
                activeGroupsKeys: [{ key: "0" }]
            })
        }
    }

    UNSAFE_componentWillMount() {
        if (["price-list"].includes(this.state.variables.document.type)) {
            let json = AppContext.getCookie(cookieKey)
            let saved = {}
            try {
                if (json) {
                    json = atob(json)
                }
                saved = json ? JSON.parse(json) : {}
                if (saved.proposalHash === this.state.variables.hash || saved.quoteId === this.state.variables.quote.id) {
                    this.setState(saved.data, this.calculatePrice)
                }
            } catch (e) { }
        } else {
            EventBus.dispatch(EventBus.TopicPricingTableOptionsSelectedChanged, {
                itemCustomAttributeValues: this.getCustomValues(),
                options: this.getOptionsSelected(),
                selectedChoices: this.getChoicesSelected(),
                multipleChoiceOptions: this.getMultipleChoiceOptions(),
                itemQuantities: this.getBillableItemQuantities()
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps || !nextProps.variables) {
            return
        }

        this.setState({
            groups: nextProps.variables.quote.groups || [],
            calendarEvents: nextProps.variables.calendarEvents || [],
            variables: nextProps.variables || null,
            items: nextProps.variables.quote.items || [],
            itemQuantities: this.formatItemQuantities(nextProps.variables),
            section: nextProps.section || null,
            optionsSelected: this.formatOptions(nextProps.variables),
            choicesSelected: this.formatSelectedChoices(nextProps.variables),
            multipleChoiceOptions: this.formatMultipleOptions(nextProps.variables),
            subtotalAmount: nextProps.variables.quote.subtotalAmount,
            discountAmount: nextProps.variables.quote.discount.amount,
            depositAmount: nextProps.variables.quote.depositAmount,
            depositBalance: nextProps.variables.quote.depositBalance,
            taxAmount: nextProps.variables.quote.taxAmount,
            totals: nextProps.variables.quote.totals,
            isPdf: nextProps.isPdf || false,
            isDummy: nextProps.isDummy || false,
            taxCalculations: nextProps.variables.quote.taxCalculations,
            totalAmountWithoutTax: nextProps.variables.quote.totalAmountWithoutTax,
            totalAmount: nextProps.variables.quote.totalAmount,
            itemOptions: this.formatItemOptions(nextProps.variables),
            mobile: nextProps.mobile || false
        })

        if (
            nextProps.enableCollapsibleGroups !== this.state.enableCollapsibleGroups ||
            nextProps.enableSingleCollapsibleGroups !== this.state.enableSingleCollapsibleGroups
        ) {
            this.setState({ activeGroupsKeys: [{ key: "0" }] })
        }
    }

    handleProposalSubmit(event) {
        this.setState({
            variables: event.getData().variables
        })
    }

    updateProposalWithSyncState(synchronizedState) {
        let newVars = this.state.variables

        //sync this.state.variables with latest pricing table changes
        newVars.items = synchronizedState.items
        newVars.quote.items = synchronizedState.items
        newVars.quote.subtotalAmount = synchronizedState.subtotalAmount
        newVars.quote.totalAmountWithoutTax = synchronizedState.totalAmountWithoutTax
        newVars.quote.balance = synchronizedState.subtotalAmount
        newVars.quote.totalAmount = synchronizedState.totalAmount
        newVars.quote.totals = synchronizedState.totals
        newVars.quote.discountAmount = synchronizedState.discountAmount
        newVars.quote.depositAmount = synchronizedState.depositAmount
        newVars.quote.depositBalance = synchronizedState.depositBalance
        newVars.quote.choicesSelected = synchronizedState.choicesSelected
        newVars.quote.multipleChoiceOptions = synchronizedState.multipleChoiceOptions
        newVars.quote.itemQuantities = synchronizedState.itemQuantities

        EventBus.dispatch(EventBus.TopicProposalRefresh, {
            variables: newVars
        })
    }

    formatItemOptions(proposal) {
        return proposal.quote.items.map(i => {
            return {
                editMode: false,
                itemId: i.id
            }
        })
    }

    getItemOption(itemId) {
        const option = this.state.itemOptions.filter(i => i.itemId === itemId)
        return option.length > 0 ? option[0] : {}
    }

    toggleItemOptionEditMode(itemId) {
        return function (event) {
            if (!this.state.editable || this.state.isDummy) {
                return
            }
            event.preventDefault()
            this.setState(
                {
                    itemOptions: this.state.itemOptions.map(i => {
                        if (i.itemId === itemId) {
                            i.editMode = !i.editMode
                        }
                        return i
                    })
                },
                () => {
                    const option = this.getItemOption(itemId)
                    if (!option.editMode) {
                        this.saveLineDescription(itemId)
                    }
                }
            )
        }.bind(this)
    }

    handleClickOutsideItem(itemId) {
        return function () {
            const option = this.getItemOption(itemId)
            if (option.editMode) {
                this.setState(
                    {
                        itemOptions: this.state.itemOptions.map(i => {
                            if (i.itemId === itemId) {
                                i.editMode = !i.editMode
                            }
                            return i
                        })
                    },
                    () => {
                        this.saveLineDescription(itemId)
                    }
                )
            }
        }.bind(this)
    }

    formatCustomValues(proposal) {
        let customValues = {}
        let modifiedCustomValues = []
        for (let index in proposal.quote.items) {
            const item = proposal.quote.items[index]
            const itemObject = item.itemObject.attributes
            if (itemObject.itemCustomAttributeValues) {
                modifiedCustomValues = itemObject.itemCustomAttributeValues.map(customVal => {
                    return {
                        customAttributeDefinitionId: customVal.attributes.customAttributeDefinitionId,
                        textValue: customVal.attributes.textValue || "",
                        selectValue: customVal.attributes.selectValue || [],
                        rowId: customVal.attributes.rowId
                    }
                })
                customValues[item.id] = modifiedCustomValues
            } else {
                customValues[item.id] = []
            }
        }
        return customValues
    }

    getCustomValues() {
        let customValues = []
        for (let rowKey in this.state.itemCustomAttributeValues) {
            if (this.state.itemCustomAttributeValues[rowKey]) {
                for (let customVal of this.state.itemCustomAttributeValues[rowKey]) {
                    customValues.push(customVal)
                }
            }
        }
        return customValues
    }

    formatOptions(proposal) {
        const options = {}
        for (let index in proposal.quote.items) {
            const item = proposal.quote.items[index]
            options[item.id] = item.isOptionChecked
        }
        return options
    }

    formatSelectedChoices(proposal) {
        const choices = {}
        for (let index in proposal.quote.items) {
            const item = proposal.quote.items[index]
            choices[item.id] = item.isChoiceSelected
        }
        return choices
    }

    formatMultipleOptions(proposal) {
        const multipleChoiceOptions = {}
        for (let index in proposal.quote.items) {
            const item = proposal.quote.items[index]
            multipleChoiceOptions[item.id] = item.isMultipleChoice && !item.isChoiceSelected
        }
        return multipleChoiceOptions
    }

    formatItemQuantities(proposal) {
        const options = {}
        for (let index in proposal.quote.items) {
            const item = proposal.quote.items[index]
            if (item.isEditableQuantity) {
                options[item.id] = item.measure
            }
        }
        return options
    }

    formatRules(proposal) {
        if (proposal.proposalType != "price-list") {
            return {
                maxCapacity: Infinity,
                rowLimits: {},
                maxProdQuantities: {}
            }
        }

        const quoteRules = proposal.quote.rules
        let rulesInfo = {
            maxCapacity: quoteRules.config.maxCapacity || Infinity,
            productLimits: quoteRules.config.productLimits || {},
            rowLimits: {}
        }
        const rowLimits = quoteRules.config.rowLimits
        const rowCounts = quoteRules.config.rowCounts
        if (rowLimits) {
            const leftOverCapacity = quoteRules.config.maxCapacity - quoteRules.config.usedCapacity
            rulesInfo["rowLimits"] = Object.entries(rowLimits).reduce((acc, [k, v]) => {
                acc[k] = rowLimits[k]
                if (rowCounts[k]) {
                    acc[k] -= rowCounts[k]
                }
                if (leftOverCapacity < acc[k]) {
                    acc[k] = leftOverCapacity
                }
                if (acc[k] < 0) {
                    acc[k] = 0
                }
                return acc
            }, {})
        }

        return rulesInfo
    }

    formatRowMaxQuantities(proposal) {
        const items = proposal.quote.items
        const rulesInfo = this.state.rulesInfo || {}
        const prodLimits = rulesInfo.productLimits || {}
        const rowLimits = rulesInfo.rowLimits || {}

        let maxQuantities = {}
        for (const item of items) {
            let maxRowQuantity = Infinity

            const productId = item.itemObject.attributes.itemObject.id
            const prodLimit = prodLimits[productId] ?? Infinity
            if (prodLimit < maxRowQuantity) {
                maxRowQuantity = prodLimit
            }

            const rowLimit = rowLimits[item.id] ?? Infinity
            if (rowLimit < maxRowQuantity) {
                maxRowQuantity = rowLimit
            }
            maxQuantities[item.id] = maxRowQuantity
        }
        return maxQuantities
    }

    calculateProductUsage(productId) {
        return this.state.items
            .filter(i => i.itemObject.attributes.itemObject.id == productId)
            .map(i => this.state.itemQuantities[i.id])
            .reduce((acc, val) => acc + parseFloat(val), 0)
    }

    handleCustomAttributeChange({ allowMoreThanOneChoice, attributeType, value: attributeValue, itemId, customAttributeDefinitionId, actionType }) {
        let itemCustomAttributeValues = Object.assign({}, this.state.itemCustomAttributeValues)
        let objIndex = itemCustomAttributeValues[itemId]?.findIndex(obj => obj.customAttributeDefinitionId === customAttributeDefinitionId)
        let customAttributeValue = {
            customAttributeDefinitionId: customAttributeDefinitionId,
            rowId: itemId
        }
        if (objIndex >= 0 && attributeType === CUSTOM_ATTRIBUTE_TYPE_TEXT.value) {
            itemCustomAttributeValues[itemId][objIndex].textValue = attributeValue
            customAttributeValue.textValue = attributeValue
            customAttributeValue.attributeType = CUSTOM_ATTRIBUTE_TYPE_TEXT.value
        } else {
            if (allowMoreThanOneChoice) {
                let newCustomField
                const existingSelectValue = this.state.itemCustomAttributeValues[itemId][objIndex].selectValue || []
                if (actionType === CUSTOM_ATRRTRIBUTES_SELECT_REMOVE_OPTION) {
                    newCustomField = {
                        customAttributeDefinitionId: customAttributeDefinitionId,
                        selectValue: [...existingSelectValue].filter(id => id !== attributeValue),
                        rowId: itemId
                    }
                }
                if (actionType === CUSTOM_ATRRTRIBUTES_SELECT_ADD_OPTION) {
                    newCustomField = {
                        customAttributeDefinitionId: customAttributeDefinitionId,
                        selectValue: [...new Set([...existingSelectValue, attributeValue])],
                        rowId: itemId
                    }
                }
                itemCustomAttributeValues[itemId][objIndex].selectValue = newCustomField.selectValue
                customAttributeValue.selectValue = newCustomField.selectValue
            } else {
                if (actionType === CUSTOM_ATRRTRIBUTES_SELECT_REMOVE_OPTION) {
                    itemCustomAttributeValues[itemId][objIndex].selectValue = []
                    customAttributeValue.selectValue = []
                }
                if (actionType === CUSTOM_ATRRTRIBUTES_SELECT_ADD_OPTION) {
                    itemCustomAttributeValues[itemId][objIndex].selectValue = [attributeValue]
                    customAttributeValue.selectValue = [attributeValue]
                }
            }
            customAttributeValue.attributeType = CUSTOM_ATTRIBUTE_TYPE_SELECT.value
        }
        this.setState(
            {
                itemCustomAttributeValues: itemCustomAttributeValues
            },
            () => {
                EventBus.dispatch(EventBus.TopicPricingTableOptionsSelectedChanged, {
                    itemCustomAttributeValues: this.getCustomValues(),
                    options: this.getOptionsSelected(),
                    selectedChoices: this.getChoicesSelected(),
                    multipleChoiceOptions: this.getMultipleChoiceOptions(),
                    itemQuantities: this.getBillableItemQuantities()
                })
            }
        )
        const payload = {
            itemCustomAttributes: [customAttributeValue]
        }
        if (this.state.variables.document.type === "quote") {
            CustomAttributeValueService.patch(this.state.variables.hash, customAttributeDefinitionId, payload)
        }
    }

    handleOptionChange(event) {
        const target = event.target
        const value = target.type === "checkbox" ? target.checked : target.value
        const name = target.name
        const options = this.state.optionsSelected
        options[name] = value

        this.setState(
            {
                optionsSelected: options
            },
            this.calculatePrice
        )
    }

    handleChoiceChange(event) {
        const target = event.target
        const value = target.type === "radio" ? target.checked : target.value
        const name = target.name
        const choices = this.state.choicesSelected
        choices[name] = value

        this.setState(
            {
                choicesSelected: choices
            },
            this.calculatePrice
        )
    }

    isQuantityValid(itemId) {
        const currQuantity = this.state.itemQuantities[itemId]
        const maxRowQuantity = this.state.maxRowQuantities[itemId]
        return currQuantity <= maxRowQuantity
    }

    isQuantityChangeValid(itemId, newQuantity) {
        const maxRowQuantity = this.state.maxRowQuantities[itemId]
        return newQuantity <= maxRowQuantity
    }

    handleQuantityChange(itemId) {
        return function (val) {
            const currentVal = this.state.itemQuantities[itemId]
            if (val > currentVal && !this.isQuantityChangeValid(itemId, val)) {
                let itemQuantities = this.state.itemQuantities
                itemQuantities[itemId] = this.state.maxRowQuantities[itemId]
                if (!this.state.itemQuantitiesShown.includes(itemId)) {
                    this.setState({
                        itemQuantitiesShown: [...this.state.itemQuantitiesShown, itemId],
                        itemQuantities: itemQuantities
                    })
                } else {
                    this.setState({ itemQuantities: itemQuantities })
                }
                return
            }
            const qty = JSON.parse(JSON.stringify(this.state.itemQuantities))
            qty[itemId] = val
            this.setState(
                {
                    itemQuantities: qty
                },
                () => {
                    this.calculatePrice()
                }
            )
        }.bind(this)
    }

    saveInCookies() {
        const fields = ["optionsSelected", "itemQuantities", "choicesSelected", "multipleChoiceOptions"]
        let data = {}
        for (let i in fields) {
            const field = fields[i]
            data[field] = this.state[field]
        }
        AppContext.setCookie(
            cookieKey,
            btoa(
                JSON.stringify({
                    proposalHash: this.state.variables.hash,

                    quoteId: this.state.variables.quote.id,

                    data: data
                })
            )
        )
    }

    getOptionsSelected() {
        let options = []
        for (let itemId in this.state.optionsSelected) {
            if (this.state.optionsSelected[itemId]) {
                options.push(itemId)
            }
        }
        return options
    }

    getChoicesSelected() {
        let choices = []
        for (let itemId in this.state.choicesSelected) {
            if (this.state.choicesSelected[itemId]) {
                choices.push(itemId)
            }
        }
        return choices
    }

    getMultipleChoiceOptions() {
        let multipleChoiceOptions = []
        for (let itemId in this.state.multipleChoiceOptions) {
            if (this.state.multipleChoiceOptions[itemId]) {
                multipleChoiceOptions.push(itemId)
            }
        }
        return multipleChoiceOptions
    }

    getBillableItemQuantities() {
        let itemQuantities = []
        for (let itemId in this.state.itemQuantities) {
            itemQuantities.push({
                itemId: itemId,
                measure: isNaN(this.state.itemQuantities[itemId]) || !this.state.itemQuantities[itemId] ? "0" : this.state.itemQuantities[itemId]
            })
        }
        return itemQuantities
    }

    calculatePrice() {
        if (!["price-list", "quote", "contract"].includes(this.state.variables.document.type)) {
            return
        }
        this.saveInCookies()

        EventBus.dispatch(EventBus.TopicPreProposalTotalUpdated, {})

        AppContext.getApiClient().setAccountId(this.state.variables.quote.accountId)
        let endPoint = "/proposals/" + this.state.variables.hash + "/pre-approve-save-pricing-table"
        if (this.state.variables.document.type === "price-list") {
            endPoint = "/proposals/" + this.state.variables.hash + "/calculate"
        }
        AppContext.getApiClient()
            .post(endPoint, {
                chosenOptions: this.getOptionsSelected(),
                selectedChoices: this.getChoicesSelected(),
                multipleChoiceOptions: this.getMultipleChoiceOptions(),
                itemQuantities: this.getBillableItemQuantities(),
                simulate: false
            })
            .then(res => {
                const variables = this.state.variables
                variables.quote.groups = res.attributes.variables.quote.groups
                this.setState({
                    subtotalAmount: res.attributes.variables.quote.subtotalAmount,
                    totalAmountWithoutTax: res.attributes.variables.quote.totalAmountWithoutTax,
                    discountAmount: res.attributes.variables.quote.discountTotalAmount,
                    totals: res.attributes.variables.quote.totals,
                    items: res.attributes.variables.quote.items,
                    depositAmount: res.attributes.variables.quote.depositAmount,
                    depositBalance: res.attributes.variables.quote.depositBalance,
                    variables: variables,
                    groups: res.attributes.variables.quote.groups
                })
                EventBus.dispatch(EventBus.TopicSyncPricingTables, this.state)
                if (this.state.variables.document.type === "price-list") {
                    EventBus.dispatch(EventBus.TopicProposalRefresh, {
                        variables: res.attributes.variables
                    })
                }
                EventBus.dispatch(EventBus.TopicProposalTotalUpdated, {
                    variables: res.attributes.variables
                })
            })

        EventBus.dispatch(EventBus.TopicPricingTableOptionsSelectedChanged, {
            itemCustomAttributeValues: this.getCustomValues(),
            options: this.getOptionsSelected(),
            selectedChoices: this.getChoicesSelected(),
            multipleChoiceOptions: this.getMultipleChoiceOptions(),
            itemQuantities: this.getBillableItemQuantities()
        })
    }

    handleLineDescriptionChange(itemId, field) {
        return function (event) {
            let items = this.state.items.map(i => {
                if (i.id === itemId) {
                    i[field] = event.target ? event.target.value : event
                }
                return i
            })
            this.setState({
                items: items
            })
        }.bind(this)
    }

    saveLineDescription(itemId) {
        let type = this.state.variables.document.type
        if (type === "packing-slip") {
            type = "invoice"
        }
        let item = this.state.items.filter(i => i.id === itemId)[0]
        if (!item) {
            return
        }
        AppContext.getApiClient()
            .patch("/" + type + "-items/" + itemId, {
                title: item.title,
                shortDescription: item.shortDescription,
                longDescription: item.longDescription
            })
            .then(r => { })
    }

    isMobile() {
        return !this.state.isPdf && (this.state.mobile || ["xs", "sm"].includes(GlobalHelper.getResponsiveBreakpoint()))
    }

    isContract() {
        return this.state.variables.document.type === "contract"
    }

    pricingTableIsEditable() {
        switch (this.state.variables.document.type) {
            case "quote":
                return !["pre-approved", "approved"].includes(this.state.variables.quote.status)
            case "price-list":
                return true
            default:
                return false
        }
    }

    getBundleItems(bundleId) {
        return this.state.items.filter(i => i.parentId === bundleId)
    }

    lastPaymentIsPending() {
        if (this.state.variables?.lastPayment?.attributes?.status !== PAYMENT_STATUS.PENDING) {
            return false
        }
        return true
    }

    renderItems(billingMethod, types, separator, groupId) {
        const isInteractionDisabled = this.state.section.attributes.content.disableInteractive
        const hasOneQuantityEditable = this.state.items.filter(i => i.isEditableQuantity).length > 0
        const hasOneAdditionalQuantity = this.state.items.filter(i => i.additionalMeasure != "0").length > 0
        let allowedItems = this.state.items.filter(i => i.billingMethod === billingMethod && groupId === i.groupId && types.includes(i.type))
        allowedItems = allowedItems.filter(i => {
            if (this.isContract() && i.isOption) {
                return this.state.optionsSelected[i.id]
            }
            return true
        })

        allowedItems = allowedItems.filter(item => {
            // filter out unselected items in custom line pricing table
            let shouldIncludeItem = true
            if ((this.state.section.attributes.content.showCustomLine && item.isOption) || (isInteractionDisabled && item.isOption)) {
                shouldIncludeItem = this.state.optionsSelected[item.id]
            } else if (
                (this.state.section.attributes.content.showCustomLine && item.isMultipleChoice) ||
                (isInteractionDisabled && item.isMultipleChoice)
            ) {
                shouldIncludeItem = this.state.choicesSelected[item.id]
            }

            if (item.itemObject?.attributes?.parentId !== "") {
                shouldIncludeItem = false
            }

            return shouldIncludeItem
        })
        let lastGroupNumber = 0

        let items = allowedItems.map((item, index) => {
            let rowClassName = []
            let label = ""
            if (item.isProvidedByCustomer) {
                label = (
                    <small>
                        <span className="badge badge-info">
                            <FormattedMessage id="proposal.items.provided_by_customer" defaultMessage="Provided by customer" />
                        </span>
                    </small>
                )
            }
            if (item.isExtraFee) {
                let quoteItemPrice = <QuoteItemPrice value={item.itemObject} />
                if (parseFloat(item.measure) > 0) {
                    quoteItemPrice = (
                        <FormattedNumber
                            style="currency"
                            currency={this.state.variables.quote.currency}
                            value={item.subtotalAmount}
                            key={"subtotal-" + item.id}
                        />
                    )
                }

                label = (
                    <small>
                        <span className="badge badge-secondary">
                            <FormattedMessage id="proposal.items.extra_fee" defaultMessage="Extra fee" />
                        </span>
                        &nbsp; &nbsp;
                        <small>{quoteItemPrice}</small>
                    </small>
                )
            }
            if (item.isIncluded) {
                label = (
                    <small>
                        <span className="badge badge-primary">
                            <FormattedMessage id="proposal.items.included" defaultMessage="Included" />
                        </span>
                    </small>
                )
            }
            let option = ""
            if (!isInteractionDisabled && item.isOption && !this.isContract() && !item.isDisabled) {
                const checked = this.state.optionsSelected[item.id]
                if (!checked) {
                    rowClassName.push("bg-light-gray")
                }
                const checkboxDisabled = !["proposed", "active", "draft"].includes(this.state.variables.quote.status) || this.lastPaymentIsPending()
                option = (
                    <div className="h5 d-flex align-items-center justify-content-end">
                        {!checked ? (
                            <label className="mb-0" htmlFor={"option-" + item.id} style={{ cursor: "pointer" }}>
                                <span
                                    className="badge badge-primary "
                                    style={{
                                        backgroundColor: this.state.variables.global.primaryColor
                                    }}
                                >
                                    {this.state.isPdf ? (
                                        <FormattedMessage id="proposal.items.option_label_not_selected" defaultMessage="Not Selected" />
                                    ) : (
                                        <>
                                            <Icon value={"plus"} className={"mr-1"} />
                                            <FormattedMessage id="proposal.items.option_label" defaultMessage="Include" />
                                        </>
                                    )}
                                </span>
                            </label>
                        ) : (
                            <label className="mb-0" htmlFor={"option-" + item.id} style={{ cursor: "pointer" }}>
                                <span className="badge badge-primary bg-success">
                                    <FormattedMessage id="proposal.items.option_selected_label" defaultMessage="Selected" />
                                </span>
                            </label>
                        )}
                        <Checkbox
                            style={{ cursor: "pointer", marginBottom: "0.1rem" }}
                            className={"ml-1"}
                            color={this.state.variables.global.primaryColor}
                            size={3}
                            borderthickness={2}
                            id={"option-" + item.id}
                            checked={checked}
                            disabled={checkboxDisabled}
                            isPdf={this.state.isPdf}
                            onChange={isChecked => {
                                const options = this.state.optionsSelected
                                options[item.id] = isChecked
                                this.setState(
                                    {
                                        optionsSelected: options
                                    },
                                    this.calculatePrice
                                )
                            }}
                        />
                    </div>
                )
            }

            if (
                index !== 0 &&
                ["multiple-choice", "choice-selected"].includes(allowedItems[index].type) &&
                !["multiple-choice", "choice-selected"].includes(allowedItems[index - 1].type)
            ) {
                lastGroupNumber += 1
            }
            const currentGroupNumber = lastGroupNumber
            if (!isInteractionDisabled && item.isMultipleChoice && this.state.variables.document.type !== "invoice" && !item.isDisabled) {
                const checked = this.state.choicesSelected[item.id]
                if (checked) {
                    rowClassName.push("line-selected")
                }
                if (!checked) {
                    rowClassName.push("bg-light-gray")
                }
                const checkboxDisabled = !["proposed", "active", "draft"].includes(this.state.variables.quote.status) || this.lastPaymentIsPending()
                option = (
                    <div className="h5 d-flex align-items-center justify-content-end">
                        {!checked ? (
                            <label className="mb-0" htmlFor={item.id} style={{ cursor: "pointer" }}>
                                <span
                                    className="badge badge-primary"
                                    style={{
                                        backgroundColor: this.state.variables.global.primaryColor
                                    }}
                                >
                                    <i className="far fa-arrow-alt-circle-right mr-2" />
                                    <FormattedMessage id="proposal.items.multiple_choice_label" defaultMessage="Choose" />
                                </span>
                            </label>
                        ) : (
                            <label className="mb-0" htmlFor={item.id} style={{ cursor: "pointer" }}>
                                <span className="badge badge-primary bg-success">
                                    <FormattedMessage id="proposal.items.choice_selected_label" defaultMessage="Selected" />
                                </span>
                            </label>
                        )}
                        <div className="custom-control custom-radio pl-0">
                            <input
                                type="radio"
                                style={{ cursor: "pointer", marginBottom: "0.1rem", display: "none" }}
                                className={"custom-control-input"}
                                color={this.state.variables.global.primaryColor}
                                size={4}
                                borderthickness={2}
                                name={`Group-${item.groupId}-${lastGroupNumber}`}
                                id={item.id}
                                checked={checked}
                                disabled={checkboxDisabled}
                                onChange={e => {
                                    let multipleChoiceGroupItemIds = findOptionsOfAMultipleChoiceGroup(
                                        item.groupId,
                                        currentGroupNumber,
                                        this.state.isPdf
                                    )
                                    let choicesSelectedModified = this.selectItemOfAMultipleChoiceGroup(multipleChoiceGroupItemIds, item.id)
                                    let multipleChoiceOptionsModified = this.unselectOtherItemsOfAMultipleChoiceGroup(
                                        multipleChoiceGroupItemIds,
                                        item.id
                                    )
                                    this.setState(
                                        {
                                            choicesSelected: choicesSelectedModified,
                                            multipleChoiceOptions: multipleChoiceOptionsModified
                                        },
                                        this.calculatePrice
                                    )
                                }}
                            />
                            <label className="custom-control-label" htmlFor={item.id}>
                                <Radio
                                    style={{ cursor: "pointer", marginBottom: "0.1rem" }}
                                    className={"ml-1"}
                                    color={this.state.variables.global.primaryColor}
                                    size={3}
                                    borderthickness={2}
                                    id={"option-" + item.id}
                                    checked={checked}
                                    disabled={checkboxDisabled}
                                />
                            </label>
                        </div>
                    </div>
                )
            }

            if (item.isDisabled) {
                option = (
                    <span className="badge badge-danger">
                        <FormattedMessage id="proposal.items.disabled_by_rules" defaultMessage="Not available" />
                    </span>
                )
            }

            let pricing = []
            let price = ""
            if (
                this.state.section.attributes.content.showLineSubTotal &&
                !item.isProvidedByCustomer &&
                !item.isExtraFee &&
                !item.isIncluded &&
                !item.hidePrice
            ) {
                price = (
                    <FormattedNumber
                        style="currency"
                        currency={this.state.variables.quote.currency}
                        value={!item.isTaxInclusive || !item.taxable ? item.subtotalAmount : item.subtotalAmountInclusive}
                        key={"subtotalAmount-" + item.id}
                    />
                )
                if (item.discountValue != 0) {
                    let discountValue = ""
                    if (item.discountType === "currency-value") {
                        discountValue = (
                            <FormattedNumber
                                style="currency"
                                currency={this.state.variables.quote.currency}
                                value={-item.discountValue}
                                key={"discountValue-" + item.id}
                            />
                        )
                    } else {
                        discountValue = (
                            <FormattedNumber style="percent" value={-(parseFloat(item.discountValue) / 100)} key={"discountValue-" + item.id} />
                        )
                    }
                    price = (
                        <div>
                            <p className="m-0 strike">
                                <FormattedNumber
                                    style="currency"
                                    currency={this.state.variables.quote.currency}
                                    value={!item.isTaxInclusive ? item.subtotalAmountWithoutDiscount : item.subtotalAmountInclusiveWithoutDiscount}
                                />
                            </p>
                            <p className="m-0">
                                ({discountValue}) &nbsp;
                                <FormattedNumber
                                    style="currency"
                                    currency={this.state.variables.quote.currency}
                                    value={!item.isTaxInclusive ? item.subtotalAmount : item.subtotalAmountInclusive}
                                />
                            </p>
                        </div>
                    )
                }
                if (price !== "") {
                    pricing.push(
                        <div key={pricing.length} onClick={() => SectionContentTypes.openSectionEditor(this.state.section.id)}>
                            {price}
                        </div>
                    )
                }
                if (item.billingMethod !== "one-time") {
                    let label = <FormattedMessage id="proposal.total.per_month_label" defaultMessage="per month" />
                    if (item.billingMethod === "yearly") {
                        label = <FormattedMessage id="proposal.total.per_year_label" defaultMessage="per year" />
                    }
                    pricing.push(
                        <p key={pricing.length} className="m-0">
                            {label}
                        </p>
                    )
                }
            }

            if (item.billingMethod !== "one-time") {
                if (item.commitmentDuration > 0) {
                    pricing.push(
                        <p key={pricing.length} className="m-0">
                            <CommitmentDurationLabel value={item.commitmentDuration} billingMethod={item.billingMethod} />
                        </p>
                    )
                }
            }
            const itemOption = this.getItemOption(item.id)

            let editButton = ""
            if (this.state.editable && !this.state.isDummy && !itemOption.editMode) {
                editButton = (
                    <div className="btn btn-sm btn-link p-0">
                        <Icon value={"edit"} />
                    </div>
                )
            }

            let title = ""
            let shortDescription = ""
            let longDescription = ""
            let assemblyInfo = ""
            let measure = ""
            let saveButton = ""
            let productPageUrl = ""
            let customAttributes = (
                <ProductCustomAttributesComponent
                    productCustomAttributeDefns={item.itemObject.attributes.itemCustomAttributeDefinitions || []}
                    documentStatus={this.state.variables.quote.status}
                    documentType={this.state.variables.document.type}
                    itemCustomAttributeValues={this.state.itemCustomAttributeValues}
                    item={item}
                    choicesSelected={this.state.choicesSelected}
                    optionsSelected={this.state.optionsSelected}
                    onHandleCustomAttributeChange={this.handleCustomAttributeChange}
                    isEditTemplateMode={this.state.editable}
                    isPdf={this.state.isPdf}
                />
            )

            let bundleItems = <></>
            if (item.itemObject?.attributes?.itemObject?.attributes?.type === PRODUCT_TYPE.BUNDLE) {
                bundleItems = <BundleOptionsDisplay
                    product={new Product(item.itemObject.attributes.itemObject)}
                    itemsOverride={this.getBundleItems(item.id)}
                    showBundleSkus={this.state.section.attributes.content.showBundleSkus}
                />
            }

            if (itemOption.editMode) {
                const RichTextEditor = require("../../../../common/rich-text/editor.component.jsx").default
                title = (
                    <div className="input-group mb-2 pr-3">
                        {editButton}
                        <input
                            name="title"
                            value={item.title}
                            onChange={this.handleLineDescriptionChange(item.id, "title")}
                            type="text"
                            className="form-control"
                        />
                    </div>
                )
                shortDescription = (
                    <div className="input-group mb-2 pr-3">
                        <textarea
                            name="shortDescription"
                            value={item.shortDescription}
                            onChange={this.handleLineDescriptionChange(item.id, "shortDescription")}
                            className="form-control"
                            rows="5"
                        />
                    </div>
                )
                longDescription = (
                    <div className="mb-2 pr-3">
                        <RichTextEditor
                            enableMergeFields={true}
                            height={400}
                            variables={this.props.variables}
                            name="content"
                            value={item.longDescription}
                            onChange={this.handleLineDescriptionChange(item.id, "longDescription")}
                            id="content"
                            className="form-control"
                        />
                    </div>
                )

                saveButton = (
                    <div className="col-12 mb-2">
                        <a className="btn btn-sm btn-outline-primary" href={"#"} onClick={this.toggleItemOptionEditMode(item.id)}>
                            <Icon value={"save"} className={"mr-1"} />
                            <FormattedMessage id="proposal.items.save_item_button" defaultMessage="Save" />
                        </a>
                    </div>
                )
            } else {
                let additionalQuantity = ""
                const times = item.unitOfMeasure !== "travel" ? <strong>×</strong> : ""
                if (!item.isExtraFee) {
                    measure = (
                        <div className="mr-1 pl-md-1">
                            <p className={"m-0 ml-lg-1 ml-sm-0"}>
                                <small>
                                    <LabelUnitOfMeasure unit={item.unitOfMeasure} value={item.measure} format="short" />
                                    &nbsp;
                                    {times}
                                </small>
                                {item.additionalMeasure != "0" ? (
                                    <small className={"ml-1"}>
                                        <LabelUnitOfMeasure unit={item.additionalUnitOfMeasure} value={item.additionalMeasure} format="short" />
                                        &nbsp;
                                        {times}
                                    </small>
                                ) : (
                                    ""
                                )}
                            </p>
                        </div>
                    )
                }

                if (!isInteractionDisabled && item.isEditableQuantity && this.pricingTableIsEditable() && !item.isDisabled) {
                    const disabled =
                        (!this.state.variables.quote.isPreApprovable && this.state.type === "quote") || item.isDisabled || this.lastPaymentIsPending()

                    let showQuantityLeft = false
                    if (this.state.variables.proposalType == "price-list") {
                        // If item has exceeded limit before
                        showQuantityLeft = this.state.itemQuantitiesShown.includes(item.id)

                        // If quant < 10
                        const maxRowQuant = this.state.maxRowQuantities[item.id] || Infinity
                        showQuantityLeft = showQuantityLeft || maxRowQuant <= 10

                        // If multiple items with same product
                        const productId = item.itemObject.attributes.itemObject.id
                        const productLimit = this.state.rulesInfo.productLimits[productId]
                        if (productLimit && productLimit < this.calculateProductUsage(productId)) {
                            showQuantityLeft = true
                        }
                    }

                    measure = (
                        <div className="mr-1" style={{ width: "4.8em" }}>
                            <InputUnitOfMeasure
                                format={"short"}
                                unit={item.unitOfMeasure}
                                value={this.state.itemQuantities[item.id]}
                                onChange={this.handleQuantityChange(item.id)}
                                type="text"
                                className="form-control"
                                debounced={true}
                                disabled={disabled}
                                verticalAlignment={true}
                            />
                            {item.additionalMeasure != "0" ? (
                                <p className={"mb-0 ml-3 ml-md-1"}>
                                    <small>
                                        <LabelUnitOfMeasure unit={item.additionalUnitOfMeasure} value={item.additionalMeasure} format="short" />
                                        &nbsp;
                                        {times}
                                    </small>
                                </p>
                            ) : (
                                ""
                            )}
                            {showQuantityLeft && this.state.maxRowQuantities[item.id] > 0 && (
                                <div className="badge badge-warning text-with-icon">
                                    <FormattedMessage
                                        id="proposal.items.row_quantity_warning_label"
                                        defaultMessage="Only {itemQuantity} left!"
                                        values={{
                                            itemQuantity: this.state.maxRowQuantities[item.id]
                                        }}
                                    />
                                </div>
                            )}
                            {showQuantityLeft && this.state.maxRowQuantities[item.id] === 0 && (
                                <div className="badge badge-warning text-with-icon">
                                    <FormattedMessage id="proposal.items.row_quantity_zero_warning_label" defaultMessage="None left!" />
                                </div>
                            )}

                            {additionalQuantity}
                        </div>
                    )
                }
                let titleText = item.title
                let unitPrice = ""
                if (this.state.section.attributes.content.showUnitPrice) {
                    unitPrice = (
                        <span className={"mr-1"}>
                            <small className={"text-secondary"}>
                                <LabelAmountPerUnitOfMeasure
                                    value={item.measure > 0 ? item.calculatedUnitPrice : item.unitPrice}
                                    currency={this.state.variables.quote.currency}
                                    unit={item.unitOfMeasure}
                                />
                            </small>
                        </span>
                    )
                }
                let unitPriceWithoutDiscount = ""
                if (this.state.section.attributes.content.showUnitPriceWithoutDiscount) {
                    unitPriceWithoutDiscount = (
                        <span className={"mr-1"}>
                            <small className={"text-secondary"}>
                                <LabelAmountPerUnitOfMeasure
                                    value={item.measure > 0 ? item.calculatedUnitPriceWithoutDiscount : item.unitPrice}
                                    currency={this.state.variables.quote.currency}
                                    unit={item.unitOfMeasure}
                                />
                            </small>
                        </span>
                    )
                }
                let manufacturers = item.product.manufacturers || ""
                if (!this.state.section.attributes.content.showManufacturer) {
                    manufacturers = ""
                }
                if (manufacturers) {
                    manufacturers = manufacturers + " - "
                }

                let productLabels = this.getFormattedLabels(
                    item.product.productLabels,
                    this.state.section.attributes.content.showProductLabels,
                    " - "
                )
                let vendorLabels = this.getFormattedLabels(
                    item.product.vendorLabels,
                    this.state.section.attributes.content.showVendorLabels,
                    " - "
                )
                let brandLabel = this.getFormattedLabels(
                    item.product.brandLabel,
                    this.state.section.attributes.content.showBrandLabel,
                    " - "
                )

                if (this.state.section.attributes.content.showProductPageUrl) {
                    productPageUrl = item.itemObject.attributes.itemObjectProductPageUrl
                    if (productPageUrl && !(productPageUrl.indexOf("://") > 0 || productPageUrl.indexOf("//") === 0)) {
                        productPageUrl = "//" + productPageUrl
                    }
                }

                let unitPriceLine =
                    unitPrice == "" ? (
                        <>
                            {unitPriceWithoutDiscount}
                            {label}
                        </>
                    ) : (
                        <>
                            {unitPrice}
                            {label}
                            <br />
                            {unitPriceWithoutDiscount}
                            {label}
                        </>
                    )

                titleText = item.isDisabled ? <strike>{titleText}</strike> : titleText
                titleText = productPageUrl ? (
                    <a href={productPageUrl} target="_blank" rel="noreferrer">
                        {titleText}
                    </a>
                ) : (
                    titleText
                )
                title = (
                    <ProductTitle
                        size={this.state.section.attributes.content.productTitleSize}
                        className="mt-0 mb-1 pb-0"
                        style={{
                            border: "none",
                            fontWeight: "600",
                            color: this.state.variables.global.primaryColor
                        }}
                        onClick={this.toggleItemOptionEditMode(item.id)}
                    >
                        {editButton} {brandLabel}
                        {manufacturers}
                        {productLabels}
                        {vendorLabels}
                        {titleText}
                        <br />
                        {unitPriceLine}
                    </ProductTitle>
                )

                let shortDescriptionText = item.shortDescription
                shortDescription = (
                    <div onClick={this.toggleItemOptionEditMode(item.id)}>
                        {shortDescriptionText.split("\n").map((item, key) => {
                            return (
                                <p className={"p-0 m-0"} key={key}>
                                    {item}
                                </p>
                            )
                        })}
                    </div>
                )

                let longDescriptionText = item.longDescription
                longDescription = (
                    <div className="rich-text" onClick={this.toggleItemOptionEditMode(item.id)}>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: ProposalMergeFields.merge(longDescriptionText, this.state.variables, this.state.isDummy, this.props.intl)
                            }}
                        />
                    </div>
                )
            }

            let documents = []
            if (item.product.documents && !this.state.section.attributes.content.hideFiles) {
                documents = item.product.documents.map((d, key) => {
                    return (
                        <p className="m-0 p-0" key={"document-" + key}>
                            <Document name={d.attributes.name} link={d.attributes.filePublicUrl} extension={d.attributes.extension} />
                        </p>
                    )
                })
            }

            let images = ""
            if (item.product.images.length > 0 && !this.state.section.attributes.content.hideImages) {
                images = <ImageGallery value={item.product.images} size={"small"} />
            }
            if (!this.state.section.attributes.content.showShortDescription) {
                shortDescription = ""
            }
            if (!this.state.section.attributes.content.showLongDescription) {
                longDescription = ""
            }

            let quantityColSize = "6em"
            if (hasOneQuantityEditable) {
                quantityColSize = "6em"
            }
            if (hasOneAdditionalQuantity) {
                quantityColSize = "8em"
            }
            let sku = ""
            if (this.state.section.attributes.content.showSku && !itemOption.editMode && item.product.sku) {
                sku = (
                    <p className={"p-0 m-0 text-secondary"}>
                        <Icon value={"hashtag"} className={"mr-1"} />
                        {item.product.sku}
                    </p>
                )
            }
            let hasDetails =
                (item.product.images.length > 0 && this.state.section.attributes.content.hideImages) ||
                (item.shortDescription && this.state.section.attributes.content.showShortDescription) ||
                (item.longDescription && this.state.section.attributes.content.showLongDescription)
            const hideForMobile = this.state.isPdf ? "" : "d-lg-block d-none"
            item.variables = this.state.variables

            if (this.state.section.attributes.content.showCustomLine) {
                rowClassName.push("px-3")
                rowClassName.push("pt-1")
            } else {
                rowClassName.push("p-3")
            }

            let rowColor = allowedItems.length - 1 === index ? "" : "border-bottom border-color-light-gray"
            rowColor = item.isDisabled ? " bg-light" : rowColor
            return (
                <div className={"row section-size " + rowClassName.join(" ") + " " + rowColor} key={item.id}>
                    <div className={"col-12"}>
                        <div className={"row"}>
                            {!this.isMobile() && this.state.section.attributes.content.showCustomLine && (
                                <table className="table table-sm table-borderless mb-0">
                                    <tbody>
                                        <tr key={index} className="d-flex">
                                            <td
                                                style={{ width: this.state.columnWidths.columnWidth1, wordBreak: "break-word" }}
                                                className="d-flex align-items-start"
                                            >
                                                <div className="rich-text text-left">
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: ProposalMergeFields.mergePricingTableLine(
                                                                this.state.section.attributes.content.customLineText1,
                                                                item,
                                                                this.state.isDummy
                                                            )
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                            <td
                                                style={{ width: this.state.columnWidths.columnWidth2, wordBreak: "break-word" }}
                                                className="d-flex align-items-start"
                                            >
                                                <div className="rich-text text-left">
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: ProposalMergeFields.mergePricingTableLine(
                                                                this.state.section.attributes.content.customLineText2,
                                                                item,
                                                                this.state.isDummy
                                                            )
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                            <td
                                                style={{ width: this.state.columnWidths.columnWidth3, wordBreak: "break-word" }}
                                                className="d-flex align-items-start justify-content-end"
                                            >
                                                <div className="rich-text text-right">
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: ProposalMergeFields.mergePricingTableLine(
                                                                this.state.section.attributes.content.customLineText3,
                                                                item,
                                                                this.state.isDummy
                                                            )
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                            <td
                                                style={{ width: this.state.columnWidths.columnWidth4, wordBreak: "break-word" }}
                                                className="d-flex align-items-start justify-content-end"
                                            >
                                                <div className="rich-text text-right">
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: ProposalMergeFields.mergePricingTableLine(
                                                                this.state.section.attributes.content.customLineText4,
                                                                item,
                                                                this.state.isDummy
                                                            )
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="d-flex">
                                            <td style={{ width: this.state.columnWidths.columnWidth1 }}></td>
                                            <td style={{ width: "75%" }}>
                                                <div className={"flex-fill " + hideForMobile}>
                                                    <div className="row">
                                                        <div className="col-12 px-0">
                                                            <OutsideClickHandler onOutsideClick={this.handleClickOutsideItem(item.id)}>
                                                                <div className="col-12">
                                                                    {shortDescription}
                                                                    {longDescription}
                                                                    {customAttributes}
                                                                    {assemblyInfo}
                                                                    {documents}
                                                                </div>
                                                            </OutsideClickHandler>
                                                        </div>

                                                        {saveButton}

                                                        {(images || bundleItems) &&
                                                            <div className="col-12 mt-2 d-flex">
                                                                {images}
                                                                {bundleItems}
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </td>
                                            <td style={{ width: this.state.columnWidths.columnWidth4 }}></td>
                                        </tr>
                                    </tbody>
                                </table>
                            )}

                            {this.isMobile() && this.state.section.attributes.content.showCustomLine && (
                                <table className="w-100">
                                    <tbody>
                                        <tr key={index + "-1"} className="d-flex">
                                            <th
                                                scope="col"
                                                style={{ width: this.state.mobileColumnWidths.columnWidth1 }}
                                                className="d-flex align-items-center pl-3"
                                            >
                                                <span className="font-weight-bold">
                                                    {this.state.section.attributes.content.customLineHeaderLabel1}
                                                </span>
                                            </th>
                                            <td
                                                className="d-flex align-items-center p-2"
                                                style={{ width: this.state.mobileColumnWidths.columnWidth2 }}
                                            >
                                                <div className="rich-text text-left">
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: ProposalMergeFields.mergePricingTableLine(
                                                                this.state.section.attributes.content.customLineText1,
                                                                item,
                                                                this.state.isDummy
                                                            )
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                        <tr key={index + "-2"} className="d-flex">
                                            <th
                                                scope="col"
                                                className="d-flex align-items-center pl-3"
                                                style={{ width: this.state.mobileColumnWidths.columnWidth1 }}
                                            >
                                                <span className="font-weight-bold">
                                                    {this.state.section.attributes.content.customLineHeaderLabel2}
                                                </span>
                                            </th>
                                            <td
                                                className="d-flex align-items-center p-2"
                                                style={{ width: this.state.mobileColumnWidths.columnWidth2 }}
                                            >
                                                <div className="rich-text text-left">
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: ProposalMergeFields.mergePricingTableLine(
                                                                this.state.section.attributes.content.customLineText2,
                                                                item,
                                                                this.state.isDummy
                                                            )
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                        <tr key={index + "-3"} className="d-flex">
                                            <th
                                                scope="col"
                                                className="d-flex align-items-center pl-3"
                                                style={{ width: this.state.mobileColumnWidths.columnWidth1 }}
                                            >
                                                <span className="font-weight-bold">
                                                    {this.state.section.attributes.content.customLineHeaderLabel3}
                                                </span>
                                            </th>
                                            <td
                                                className="d-flex align-items-center justify-content-start p-2"
                                                style={{ width: this.state.mobileColumnWidths.columnWidth2 }}
                                            >
                                                <div className="rich-text text-left">
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: ProposalMergeFields.mergePricingTableLine(
                                                                this.state.section.attributes.content.customLineText3,
                                                                item,
                                                                this.state.isDummy
                                                            )
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                        <tr key={index + "-4"} className="d-flex">
                                            <th
                                                scope="col"
                                                className="d-flex align-items-center pl-3"
                                                style={{ width: this.state.mobileColumnWidths.columnWidth1 }}
                                            >
                                                <span className="font-weight-bold">
                                                    {this.state.section.attributes.content.customLineHeaderLabel4}
                                                </span>
                                            </th>
                                            <td
                                                className="d-flex align-items-center justify-content-start p-2"
                                                style={{ width: this.state.mobileColumnWidths.columnWidth2 }}
                                            >
                                                <div className="rich-text text-left">
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: ProposalMergeFields.mergePricingTableLine(
                                                                this.state.section.attributes.content.customLineText4,
                                                                item,
                                                                this.state.isDummy
                                                            )
                                                        }}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            )}

                            <div
                                className={
                                    "col-lg-12 col-md-12 d-flex px-lg-0 mb-2 mb-sm-0 " +
                                    (hasDetails && this.state.section.attributes.content.showCustomLine ? "mt-3" : "")
                                }
                            >
                                {!this.state.section.attributes.content.showCustomLine && (
                                    <div className="mr-2" style={{ width: quantityColSize }}>
                                        {!item.isEditableQuantity || !this.pricingTableIsEditable() ? (
                                            <h5
                                                className="mt-0 mb-0 pb-0"
                                                style={{ border: "none", width: quantityColSize }}
                                                onClick={this.toggleItemOptionEditMode(item.id)}
                                            >
                                                {measure}
                                            </h5>
                                        ) : (
                                            <h6
                                                className="mt-0 mb-0 pb-0"
                                                style={{ border: "none", width: quantityColSize }}
                                                onClick={this.toggleItemOptionEditMode(item.id)}
                                            >
                                                {measure}
                                            </h6>
                                        )}
                                    </div>
                                )}

                                {!this.state.section.attributes.content.showCustomLine && (
                                    <div className={"flex-fill " + hideForMobile}>
                                        <div className="row">
                                            <div className="col-12 px-0">
                                                <OutsideClickHandler onOutsideClick={this.handleClickOutsideItem(item.id)}>
                                                    <div className="col-12">
                                                        {title}
                                                        {sku}
                                                        {!this.state.section.attributes?.content?.hideSerialNumber && (
                                                            <SerialNumberLabelListing serialNumbers={item.serialNumbers} isPdf={this.state.isPdf} />
                                                        )}
                                                    </div>
                                                    <div className="col-12">
                                                        {shortDescription}
                                                        {longDescription}
                                                        {assemblyInfo}
                                                        {documents}
                                                    </div>
                                                </OutsideClickHandler>
                                                {saveButton}
                                                {customAttributes}
                                            </div>

                                            {(images || bundleItems) &&
                                                <div className="col-12 mt-2 d-flex">
                                                    {images}
                                                    {bundleItems}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                )}

                                {!this.state.section.attributes.content.showCustomLine && (
                                    <div className={hideForMobile + " text-secondary"} style={{ textAlign: "right" }}>
                                        {pricing} {option}
                                    </div>
                                )}
                            </div>
                            {this.state.isPdf ? (
                                ""
                            ) : (
                                <div className="col-md-10 col-sm-12 d-lg-none">
                                    <div className="row">
                                        {!this.state.section.attributes.content.showCustomLine && [
                                            <div className="col-12">
                                                {title}
                                                {sku}
                                                {!this.state.section.attributes?.content?.hideSerialNumber && (
                                                    <SerialNumberLabelListing serialNumbers={item.serialNumbers} isPdf={this.state.isPdf} />
                                                )}
                                            </div>,
                                            <div className="col-12 text-secondary">
                                                {pricing} {option}
                                            </div>
                                        ]}
                                        <div className={"col-12"}>
                                            {shortDescription}
                                            {longDescription}
                                            {assemblyInfo}
                                            {documents}
                                        </div>
                                        {saveButton}
                                        {customAttributes}

                                        {(images || bundleItems) &&
                                            <div className="col-12 mt-2 d-flex">
                                                {images}
                                                {bundleItems}
                                            </div>
                                        }
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )
        })
        if (items.length > 0 && separator) {
            items.unshift(<li className="media mb-5 border-bottom border-dark" style={{ opacity: 0.1 }} key={"separator-" + items.length} />)
        }

        return items
    }

    getFormattedLabels(labels, shouldShow, separator) {
        if (!shouldShow) {
            return ""
        }

        let formattedLabels = labels || ""
        if (formattedLabels && formattedLabels.length > 0) {
            formattedLabels = formattedLabels.join(separator) + " - "
        }

        return formattedLabels
    }

    getBillingMethodOrder() {
        const defaultOrder = ["one-time", "monthly", "yearly"]
        const hasRankSet = this.state.variables.quote.items.filter(i => i.itemObject.attributes.rank !== 0).length > 0
        if (!hasRankSet) {
            return defaultOrder
        }
        const list = this.state.variables.quote.groups.length > 0 ? this.state.variables.quote.groups : this.state.variables.quote.items
        const methods = list
            .map(g => {
                return g.attributes ? g.attributes.billingMethod : g.billingMethod
            })
            .filter((value, index, self) => {
                return self.indexOf(value) === index
            })

        for (let index in defaultOrder) {
            const method = defaultOrder[index]
            if (!methods.includes(method)) {
                methods.push(method)
            }
        }
        return methods
    }

    getCustomHeader(className) {
        return (
            <div className={"row section-size px-3"}>
                <table className={"table table-sm mb-0 " + className} key={2}>
                    <thead>
                        <tr>
                            <th style={{ width: this.state.columnWidths.columnWidth1 }} scope="col" className="text-left border-top-0">
                                <small className="font-weight-bold">{this.state.section.attributes.content.customLineHeaderLabel1}</small>
                            </th>
                            <th style={{ width: this.state.columnWidths.columnWidth2 }} scope="col" className="text-left border-top-0">
                                <small className="font-weight-bold">{this.state.section.attributes.content.customLineHeaderLabel2}</small>
                            </th>
                            <th style={{ width: this.state.columnWidths.columnWidth3 }} scope="col" className="text-right border-top-0">
                                <small className="font-weight-bold">{this.state.section.attributes.content.customLineHeaderLabel3}</small>
                            </th>
                            <th style={{ width: this.state.columnWidths.columnWidth4 }} scope="col" className="text-right border-top-0">
                                <small className="font-weight-bold">{this.state.section.attributes.content.customLineHeaderLabel4}</small>
                            </th>
                        </tr>
                    </thead>
                </table>
            </div>
        )
    }

    getEndPoint() {
        switch (this.state.variables.document.type) {
            case "invoice":
                return "/invoices/" + this.state.variables.quote.id
            case "order":
                return "/orders/" + this.state.variables.quote.id
            case "quote":
                return "/quotes/" + this.state.variables.quote.id
        }
    }

    onChangeGroup() {
        AppContext.getApiClient()
            .get(this.getEndPoint())
            .then(response => {
                this.setState({ groups: response.attributes.groups })
            })
    }

    handleGroupSelect = eventKey => {
        if (!this.state.section.attributes.content.enableSingleCollapsibleGroups) {
            const index = this.state.activeGroupsKeys.findIndex(function (obj) {
                return obj.key === eventKey
            })
            if (index > -1) {
                this.setState({
                    activeGroupsKeys: this.state.activeGroupsKeys.filter(obj => obj.key !== eventKey)
                })
            } else {
                let groupsKeys = this.state.activeGroupsKeys
                groupsKeys.push({ key: eventKey })
                this.setState({
                    activeGroupsKeys: groupsKeys
                })
            }
        } else {
            if (this.state.activeGroupsKeys[0]?.key === eventKey) {
                this.setState({
                    activeGroupsKeys: []
                })
            } else {
                this.setState({
                    activeGroupsKeys: [{ key: eventKey }]
                })
            }
        }
    }

    activeGroupsKeysContains = eventKey => {
        return this.state.activeGroupsKeys.some(element => element.key === eventKey)
    }

    render() {
        if (!this.state.variables) {
            return <div />
        }
        const billingMethods = GlobalHelper.unique(this.state.variables.quote.items.map(r => r.billingMethod))

        const orders = this.getBillingMethodOrder()
        const totals = this.state.totals
            .sort((a, b) => {
                return orders.indexOf(a.attributes.billingMethod) - orders.indexOf(b.attributes.billingMethod)
            })
            .filter(t => billingMethods.includes(t.attributes.billingMethod))
        return (
            <SectionWrapper
                id={"pricingTable"}
                section={this.state.section}
                onEdit={this.state.onEdit}
                editable={this.state.editable}
                variables={this.state.variables}
                clickable={false}
                noContainer={true}
                isPdf={this.state.isPdf}
            >
                <form>
                    {totals.map((t, i) => {
                        const rows = this.state.groups
                            .filter(g => g.attributes.billingMethod === t.attributes.billingMethod)
                            .map((g, idx) => {
                                let pricing = []
                                let label = ""
                                if (g.attributes.billingMethod !== "one-time") {
                                    label = (
                                        <span className={"mr-2"}>
                                            <small>
                                                <em>
                                                    <BillingMethodLabel value={g.attributes.billingMethod} masculine={true} />
                                                </em>
                                            </small>
                                        </span>
                                    )
                                }
                                const shouldShowSubtotalAmount =
                                    !this.state.section.attributes.content.showGroupInclusiveSubtotal ||
                                    AppContext.getAccount()?.attributes?.isTaxInclusive
                                pricing.push(
                                    <p className="m-0" key={pricing.length}>
                                        {label}
                                        <FormattedNumber
                                            style="currency"
                                            currency={g.attributes.currency}
                                            value={shouldShowSubtotalAmount ? g.attributes.subtotalAmount : g.attributes.subtotalAmountInclusive}
                                        />
                                    </p>
                                )

                                const groupHeader = (
                                    <React.Fragment key={idx}>
                                        <div className={"flex-grow-1 align-self-center"}>
                                            <span>
                                                <QuoteGroupName
                                                    showDescription={false}
                                                    value={g}
                                                    quoteId={this.state.variables.quote.id}
                                                    invoiceId={this.state.variables.quote.id}
                                                    documentId={this.state.variables.quote.id}
                                                    type={this.state.variables.document.type}
                                                    editable={this.state.editable}
                                                    withEditIcon={true}
                                                    onChange={this.onChangeGroup}
                                                    groupCalendarEventIds={g.calendarEventIds}
                                                    documentCalendarEvents={this.state.calendarEvents}
                                                    isPdf={this.props.isPdf ? this.props.isPdf : false}
                                                />
                                            </span>
                                        </div>
                                        {!this.state.section.attributes.content.hideGroupSubtotal && (
                                            <small className={"align-self-center"}>
                                                <strong>{pricing}</strong>
                                            </small>
                                        )}
                                    </React.Fragment>
                                )
                                const groupHeaderExtra = (
                                    <React.Fragment key={idx}>
                                        {this.state.section.attributes.content.showGroupDescription && (
                                            <div className={"flex-grow-1 align-self-center pt-2 pb-2 px-3 d-flex"}>
                                                <div className={"rich-text"} dangerouslySetInnerHTML={{ __html: g.attributes.description }} />
                                            </div>
                                        )}
                                        {!this.state.section.attributes.content.hideCalendarEvents && (
                                            <div className="ml-3">
                                                <GroupCalendarEventsDescription
                                                    calendarEvents={g.attributes.calendarEvents}
                                                    timezone={this.state.variables.document.locationTimezone}
                                                />
                                            </div>
                                        )}
                                    </React.Fragment>
                                )
                                const groupBody = (
                                    <React.Fragment key={idx}>
                                        {groupHeaderExtra}
                                        {!this.isMobile() && this.state.section.attributes.content.showCustomLine ? this.getCustomHeader("") : ""}
                                        {this.state.section.attributes.content.hideItems ? (
                                            ""
                                        ) : (
                                            <div className={"p-2"}>
                                                {this.renderItems(
                                                    t.attributes.billingMethod,
                                                    [
                                                        "active",
                                                        "option-for-customer",
                                                        "provided-by-customer",
                                                        "chosen-by-customer",
                                                        "included",
                                                        "editable-quantity",
                                                        "multiple-choice",
                                                        "choice-selected"
                                                    ],
                                                    false,
                                                    g.id
                                                )}
                                            </div>
                                        )}
                                    </React.Fragment>
                                )
                                const nonCollapsibleGroup = (
                                    <div className={"row section-size"} key={"group-title-" + g.id}>
                                        <div className="col-12 p-0">
                                            <div
                                                className={"text-white border-0 pt-2 pb-2 px-3 d-flex "}
                                                style={{
                                                    backgroundColor: this.state.variables.global.groupTitleBackgroundColor || "#6c757d"
                                                }}
                                            >
                                                {groupHeader}
                                            </div>
                                        </div>
                                    </div>
                                )

                                const accordionSimpleSelect = (
                                    <Accordion
                                        key={idx}
                                        activeKey={this.activeGroupsKeysContains(idx.toString()) ? idx.toString() : ""}
                                        defaultActiveKey={this.activeGroupsKeysContains(idx.toString()) ? idx.toString() : ""}
                                    >
                                        <Card className="collapsible-card">
                                            <Accordion.Toggle
                                                as="div"
                                                type="button"
                                                className={"text-white border-0 pt-2 pb-2 px-3 d-flex"}
                                                style={{
                                                    backgroundColor: this.state.variables.global.groupTitleBackgroundColor || "#6c757d"
                                                }}
                                                eventKey={idx.toString()}
                                                onClick={() => this.handleGroupSelect(idx.toString())}
                                            >
                                                <span className="collapsible-header-arrow">
                                                    <Icon
                                                        value={this.activeGroupsKeysContains(idx.toString()) ? "chevron-down" : "chevron-right"}
                                                        key={idx}
                                                    />
                                                </span>
                                                {groupHeader}
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey={idx.toString()}>{groupBody}</Accordion.Collapse>
                                        </Card>
                                    </Accordion>
                                )

                                const accordionMultipleSelect = (
                                    <Accordion
                                        key={idx}
                                        activeKey={this.activeGroupsKeysContains(idx.toString()) ? idx.toString() : ""}
                                        defaultActiveKey={this.activeGroupsKeysContains(idx.toString()) ? idx.toString() : ""}
                                    >
                                        <Card className="collapsible-card">
                                            <Accordion.Toggle
                                                as="div"
                                                type={"button"}
                                                className={"text-white border-0 pt-2 pb-2 px-3 d-flex"}
                                                style={{
                                                    backgroundColor: this.state.variables.global.groupTitleBackgroundColor || "#6c757d"
                                                }}
                                                eventKey={idx.toString()}
                                                onClick={() => this.handleGroupSelect(idx.toString())}
                                            >
                                                <span className="collapsible-header-arrow">
                                                    <Icon
                                                        value={this.activeGroupsKeysContains(idx.toString()) ? "chevron-down" : "chevron-right"}
                                                        key={idx}
                                                    />
                                                </span>
                                                {groupHeader}
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey={idx.toString()}>{groupBody}</Accordion.Collapse>
                                        </Card>
                                    </Accordion>
                                )
                                return [
                                    this.state.section.attributes.content.enableCollapsibleGroups && !this.state.isPdf ? (
                                        <div className={"row section-size"} key={"group-title-" + g.id}>
                                            <div className="col-12 p-0">
                                                {!this.state.section.attributes.content.enableSingleCollapsibleGroups
                                                    ? accordionMultipleSelect
                                                    : accordionSimpleSelect}
                                            </div>
                                        </div>
                                    ) : (
                                        nonCollapsibleGroup
                                    ),
                                    (!this.state.section.attributes.content.enableCollapsibleGroups || this.state.isPdf) && groupBody
                                ]
                            })
                        let title = ""
                        const itemsLength = this.state.variables.quote.items.filter(
                            i => i.billingMethod === t.attributes.billingMethod && "" === i.groupId
                        ).length
                        if (itemsLength > 0) {
                            if (billingMethods.length > 1 && t.attributes.billingMethod !== "one-time") {
                                let label = <FormattedMessage id="proposal.items.billing_method.title.monthly" defaultMessage="Monthly recurring" />
                                if (t.attributes.billingMethod === "yearly") {
                                    label = <FormattedMessage id="proposal.items.billing_method.title.yearly" defaultMessage="Yearly recurring" />
                                }
                                title = (
                                    <div className="col-12 p-0" key={"billing-method-" + rows.length}>
                                        <h5
                                            className={"text-white border-0 pt-2 pb-2 px-3 d-flex "}
                                            style={{
                                                backgroundColor: this.state.variables.global.groupTitleBackgroundColor || "#6c757d"
                                            }}
                                        >
                                            <strong>{label}</strong>
                                        </h5>
                                    </div>
                                )
                            }
                        }
                        if (title) {
                            rows.push(
                                <div className={"row section-size"} key={"no-group-" + rows.length}>
                                    {title}
                                </div>
                            )
                        }

                        if (!this.state.section.attributes.content.hideItems) {
                            rows.push(
                                this.renderItems(
                                    t.attributes.billingMethod,
                                    [
                                        "active",
                                        "option-for-customer",
                                        "provided-by-customer",
                                        "chosen-by-customer",
                                        "included",
                                        "editable-quantity",
                                        "multiple-choice",
                                        "choice-selected"
                                    ],
                                    false,
                                    ""
                                )
                            )
                        }

                        if (!this.state.section.attributes.content.hideTotals) {
                            rows.push(
                                <div className={"row section-size border-top pt-3"} key={"no-group-" + rows.length}>
                                    <div
                                        className={"col-12 " + (totals.length - 1 !== i ? "mb-5" : "")}
                                        onClick={() => SectionContentTypes.openSectionEditor(this.state.section.id)}
                                    >
                                        <DocumentPricingTableTotal
                                            isPdf={this.state.isPdf}
                                            total={t}
                                            showTaxes={this.state.section.attributes.content.showTaxes}
                                            showTotalQuantitiesByUnitGroup={this.state.section.attributes.content.showTotalQuantitiesByUnitGroup}
                                            unitGroupsToDisplay={this.state.section.attributes.content.unitGroupsToDisplay}
                                            hideDeposit={this.state.section.attributes.content.hideDeposit}
                                            hideDueDate={this.state.section.attributes.content.hideDueDate}
                                            depositAmount={this.state.depositAmount}
                                            variables={this.state.variables}
                                            depositRatio={this.state.variables.quote.depositRatio}
                                            depositType={this.state.variables.quote.depositType}
                                            balance={this.state.variables.quote.balance}
                                            depositBalance={this.state.depositBalance}
                                            payments={this.state.variables.quote.payments}
                                            proposalType={this.state.variables.document.type}
                                            dueDate={this.state.variables.document.dueDate}
                                            invoices={this.state.variables.quote.invoices}
                                        />
                                    </div>
                                </div>
                            )
                        }
                        return [
                            this.state.variables.quote.groups.length == 0 && !this.isMobile() && this.state.section.attributes.content.showCustomLine
                                ? this.getCustomHeader("mt-3")
                                : "",
                            rows
                        ]
                    })}
                </form>
            </SectionWrapper>
        )
    }
}

export default injectIntl(PricingTableContentSection)



// WEBPACK FOOTER //
// ./src/template/sections/content/pricing-table/section.component.jsx